import axios from 'axios';

const instance = axios.create({ 
  baseURL: "https://d-vour-api.herokuapp.com/",
  headers: {
    'Content-type': 'application/json'
  },});

export default instance